import { createContext, useContext } from "react";
const BraidThemeContext = createContext(null);
const useBraidTheme = () => {
  const braidTheme = useContext(BraidThemeContext);
  if (braidTheme === null) {
    throw new Error("No Braid theme available on context");
  }
  return braidTheme;
};
export {
  BraidThemeContext,
  useBraidTheme
};
